export const SET_USER = 'SET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_SETTING = 'SET_SETTING'
export const SET_CONVO_LIST = 'SET_CONVO_LIST'
export const ADD_CONVO = 'ADD_CONVO'
export const UPDATE_CONVO = 'UPDATE_CONVO'
export const DELETE_CONVO_LIST = 'DELETE_CONVO_LIST'
export const SET_ORIGIN_VIEWPORT = 'SET_ORIGIN_VIEWPORT'
export const SET_VIEWPORT = 'SET_VIEWPORT'
export const SET_MODIFIED_VIEWPORT = 'SET_MODIFIED_VIEWPORT'
export const SET_WINDOW_MODE = 'SET_WINDOW_MODE'
export const SET_NOW = 'SET_NOW'
export const SET_POSITION = 'SET_POSITION'
export const ADD_EVENT = 'ADD_EVENT'
export const ADD_EVENTS = 'ADD_EVENTS'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const UPDATE_SEEN_MESSAGE = 'UPDATE_SEEN_MESSAGE'
export const UPDATE_RECEIVED_MESSAGE = 'UPDATE_RECEIVED_MESSAGE'
export const SET_CONVO_LIST_END = 'SET_CONVO_LIST_END'
export const SET_USER_READY = 'SET_USER_READY'
export const SET_SETTING_READY = 'SET_SETTING_READY'
export const SET_WS_READY = 'SET_WS_READY'
export const SET_CSS_READY = 'SET_CSS_READY'
export const SET_LANGUAGE_READY = 'SET_LANGUAGE_READY'
export const SET_CONVO_LIST_READY = 'SET_CONVO_LIST_READY'
export const SET_LAST_CONVO_ID = 'SET_LAST_CONVO_ID'
export const SET_EVENT_ANCHORS = 'SET_EVENT_ANCHORS'
export const SET_EVENT_ENDS = 'SET_EVENT_ENDS'
export const SET_BASE_SETTING_READY = 'SET_BASE_SETTING_READY'
export const SET_BASE_SETTING = 'SET_BASE_SETTING'
export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_MASK = 'SET_USER_MASK'
export const SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE'
export const RESET = 'RESET'
export const SET_GEOIP = 'SET_GEOIP'
export const UPDATE_EVENT_CAPTURE_LEAD = 'UPDATE_EVENT_CAPTURE_LEAD'
export const SET_ALL_READY = 'SET_ALL_READY'
export const SET_THEME_COLOR = 'SET_THEME_COLOR'
export const SET_FCM_TOKEN = 'SET_FCM_TOKEN'
export const SET_CUSTOM_SCREEN = 'SET_CUSTOM_SCREEN'
export const SET_LAST_SCREEN_ID = 'SET_LAST_SCREEN_ID'
export const SET_OFFLINE = 'SET_OFFLINE'
export const SET_HOVERING = 'SET_HOVERING'
export const SET_FOCUSMESSAGEINPUT = 'SET_FOCUSMESSAGEINPUT'
export const SET_CONNECTION_ID = 'SET_CONNECTION_ID'
export const SET_DEVICE = 'SET_DEVICE'
export const SET_DOM_READY = 'SET_DOM_READY'
export const DELETE_EVENTS = 'DELETE_EVENTS'
export const SET_PARENT_TITLE = 'SET_PARENT_TITLE'
export const SET_PARENT_HREF = 'SET_PARENT_HREF'
